export default {
    savedPlaces: 'Your saved places will show here',
    filterResult: "Uh-oh. Let's eat something else.",
    recommendedPlaces: 'Your recommended places will show here',
    searchResult: "Uh-oh. Not finding what you're looking for?"
}